export default __webpack_public_path__ + "static/media/LogoBlack.7f4afeba.png";